import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router";
import {useAuth} from "../context/authContext.tsx";
import { loginLService } from "../services/employee.ts";
import Label from "../components/Label.tsx";
import Input from "../components/input/InputField.tsx";
import Button from "../components/button/button.tsx";
import { AxiosError } from "axios";
import { useAuthOTP } from "../context/auth/authOtpContext.tsx";
import { getAuthenticatedHomeRoute } from "../utils/auth.ts";
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

const GenerateOTP = () => {
    const [email, setEmail] = useState<string>("");
    const [errors, setErrors] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const {setEmailOtp} = useAuthOTP();

    const { employeeI, authReady } = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        if (!authReady || !employeeI) {
            return;
        }
        navigate(getAuthenticatedHomeRoute(employeeI), { replace: true });
    }, [authReady, employeeI, navigate]);

    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (loading) return;
        setErrors("");
        setLoading(true);
        try {
            await loginLService({
                email: email,
            })
            setEmailOtp(email);
            navigate("/otp", { replace: true });
        } catch (error) {
            if (error instanceof AxiosError) {
                if (error.response) {
                    if (error.response.status === 500) {
                        setErrors("Something on our end went wrong");
                        setLoading(false);
                        return;
                    }
                    if (error.response.data) {
                        setErrors(error.response.data.error);
                        setLoading(false);
                        return;
                    }
                    setErrors("Something went wrong!");
                    setLoading(false);
                    return;
                }
                setErrors("Something went wrong!");
                setLoading(false);
                return;
            }
            setErrors("Something went wrong!");
        }
        setLoading(false);
    }

    return (
        <div className="flex min-h-screen w-full bg-cover bg-center relative" style={{ backgroundImage: `url('${digitalOceanImageUrl("assets/images/_99A0320.JPG")}')` }}>
            <div className="absolute inset-0 bg-blue-900/40"></div>
            {/* <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto "> */}
                    {/* Left side - Login Form */}
            
                <div className="w-2xl md:w-1/2 flex items-center justify-center flex flex-col justify-center flex-1 w-full max-w-96 max-w-md mx-auto">
                    <div className="w-full max-md:max-w-md  mx-auto">
                        <div className=" rounded-xl shadow-md px-10 py-12 backdrop-blur-md bg-black/10  rounded-xl shadow-lg">
                            <div className="mt-6 text-center lg:hidden">
                                <Link to="/">
                                    <img
                                    src={digitalOceanImageUrl("assets/images/logo.png")}
                                    alt="Logo"
                                    className="mx-auto mb-2 w-32 h-auto"
                                    />
                                </Link>
                                <p className="text-white text-sm">
                                    Production Process Portal
                                </p>
                            </div>
                            <div className="mb-6 w-full max-w-96 ">
                                {errors.length > 0 && (
                                    <small className="px-2 py-1.5 mb-4 block bg-blue-300/70 rounded-md text-red-500">{errors}</small>
                                )}
                                <h1 className="text-2xl items-center justify-center font-semibold text-white mb-2">
                                    Generate Login OTP
                                </h1>
                                <p className="text-sm text-white">
                                    Enter your company email to generate OTP!
                                </p>
                            </div>
                            
                            <form onSubmit={submitHandler}>
                                <div className="space-y-6">
                                    <div className="backdrop-blur-sm bg-white/30 p-4 rounded-lg">
                                        <Label className="text-gray-50">
                                            Email <span className="text-blue-500">*</span>
                                        </Label>
                                        <Input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type="email" 
                                            placeholder="jon@kiiramotors.com" 
                                            className="bg-gray-100 rounded-md text-white border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                        />
                                    </div>

                                    <div>
                                        <Button 
                                            disabled={loading} 
                                            className="w-full bg-blue-600 hover:bg-blue-700 text-white" 
                                            size="sm"
                                        >
                                            {loading ? "Generating..." : "Generate OTP"}
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            {/* </div> */}
            
            {/* Right side - Dark background with logo */}
            {/* <div className="hidden md:flex md:w-1/2 items-center justify-center relative backdrop-blur-md bg-black/10">  
                <div className="relative z-10 flex flex-col items-center">
                    <img
                        src={digitalOceanImageUrl("assets/images/logo.png")}
                        alt="KMC Logo"
                        className="w-32 h-auto mb-4"
                    />
                    <p className="text-white font-bold text-5xl">
                        Production Processes Portal
                    </p>
                </div>
                
                </div> */}
            <div className="hidden md:flex md:w-1/2 items-center justify-center relative backdrop-blur-md bg-black/10">  
                <div className="relative z-10 flex flex-col items-center">
                    <img
                        src={digitalOceanImageUrl("assets/images/logo.png")}
                        alt="KMC Logo"
                        className="w-60 h-50 mb-4"
                    />
                    <p className="text-white font-bold text-3xl">
                        Production Processes Portal
                    </p>
                </div>
            
            </div>
        </div>
    );
};

export default GenerateOTP;
